// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ArrowUpRight } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconArrowUpRight(props: any) {
    return <IconBase icon={ArrowUpRight} {...props} />
  }

  export default IconArrowUpRight
  